import 'Onboarding/angularModule';
import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const ForgotPasswordDirective = angularDirectiveToReact('onboardingForgotPassword', {});

export function ForgotPasswordComponent() {
    const [key] = useAngularToReactRoute();
    return <ForgotPasswordDirective key={key} />;
}
